import { t } from '../i18n.ts';
import { h } from './dom.ts';
import { ICONS } from './icons.ts';

type Res = 'wood' | 'stone' | 'crystal' | 'dust' | 'iron';

let open: { tip: HTMLElement; timer: number; off: (e: PointerEvent) => void } | null = null;

const close = (): void => {
  if (!open) return;
  open.tip.remove();
  window.clearTimeout(open.timer);
  document.removeEventListener('pointerdown', open.off, true);
  open = null;
};

/**
 * A small card under a resource chip: what it is, how much there is, where it comes from and what it pays for.
 * Tapping the same chip again, anywhere else, or waiting closes it.
 */
export const showResTip = (chip: HTMLElement, k: Res, have: number, where: 'bastion' | 'battle'): void => {
  const again = open?.tip.dataset.res === k;
  close();
  if (again) return;
  const host = chip.offsetParent as HTMLElement | null;
  if (!host) return;
  const tip = h(
    'div.restip',
    { role: 'tooltip', 'data-res': k },
    h('div.restip-head', {}, h('span', { html: ICONS[k] }), h('b', {}, t(`res.${k}`)), h('span.restip-n', {}, String(have))),
    h('p', {}, t(`restip.${k}.use`)),
    h('p.small', {}, t(where === 'bastion' ? `restip.${k}.from` : 'restip.battle')),
  );
  host.append(tip);
  const hr = host.getBoundingClientRect();
  const cr = chip.getBoundingClientRect();
  const w = tip.offsetWidth;
  const left = Math.max(8, Math.min(hr.width - w - 8, cr.left - hr.left + cr.width / 2 - w / 2));
  tip.style.left = `${left}px`;
  tip.style.top = `${cr.bottom - hr.top + 8}px`;
  const off = (e: PointerEvent): void => {
    if (!tip.contains(e.target as Node) && !chip.contains(e.target as Node)) close();
  };
  document.addEventListener('pointerdown', off, true);
  open = { tip, timer: window.setTimeout(close, 6000), off };
};
